import { Button } from "@app/ui";
import { useTranslate } from "@fe/i18n/use-translate";
import type { FC } from "react";

export const ErrorFC: FC<{ abortStatusCode?: number }> = ({
	abortStatusCode,
}) => {
	const t = useTranslate();

	const message =
		t.errorMessages.errors[
			abortStatusCode as keyof typeof t.errorMessages.errors
		] ?? t.errorMessages.errors.generic;

	return (
		<div className="flex flex-col items-center justify-center h-dvh w-full gap-4 text-center">
			<h3 className="text-3xl font-bold">{t.errorMessages.whoops}</h3>
			<p className="text-base">{message}</p>
			<Button variant="outline" asChild>
				<a href="/">{t.errorMessages.goToProjects}</a>
			</Button>
		</div>
	);
};
